"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.propAccessor2 = exports.NA = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
exports.NA = 'N/A';
var propAccessor2 = function (detail, propertyActivations) {
    return function (propPath, altValue) {
        if (altValue === void 0) { altValue = exports.NA; }
        var prop = ui_common_1.objectUtils.get(detail, propPath, altValue);
        var activations = ui_common_1.objectUtils.get(propertyActivations, propPath, []);
        var visible = activations.some(function (activation) { return activation.selectionState.visible; });
        if (!visible) {
            return prop !== null ? prop : altValue;
        }
        var highlighted = prop;
        activations.forEach(function (activation) {
            var active = activation.selectionState.active;
            var styleClasses = [
                "evidence",
                'highlighted-text',
                {
                    'evidence-categorical': true,
                    'qa-evidence-categorical': true,
                    'evidence-active': active,
                    'qa-evidence-active': active
                },
                "evidence-".concat(activation.meta.codeType),
                "evidence-".concat(activation.meta.provenance)
            ];
            highlighted = ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: highlighted })));
        });
        return highlighted;
    };
};
exports.propAccessor2 = propAccessor2;
//# sourceMappingURL=case-prop-accessor2.js.map